import getScenarioStore from './getScenarioStore';
import { SearchScenarioId } from '../store/schema/SearchScenarioId';

export default function hasSuggestionPills(scenarioId: SearchScenarioId): boolean {
    const store = getScenarioStore(scenarioId);
    return !!store.suggestionPills.size || !!store.suggestionSegments.size;
}
